import { defineComponent as g, computed as d, openBlock as o, createElementBlock as v, normalizeClass as e, createElementVNode as p, createCommentVNode as V, ref as N, createVNode as C, toDisplayString as x, Fragment as $, renderList as A, renderSlot as z, useAttrs as S, createBlock as b, resolveDynamicComponent as k, mergeProps as L, withCtx as m, unref as h, watch as j, createTextVNode as B, withDirectives as I, vModelRadio as Q, vModelText as D } from "vue";
import { Menu as P, MenuButton as E, MenuItems as q, MenuItem as R, Popover as O, PopoverButton as F, PopoverPanel as X, Dialog as Y, DialogPanel as U, DialogTitle as G } from "@headlessui/vue";
import { v4 as _ } from "uuid";
const W = (i) => Object.fromEntries(
  Object.entries(i).filter(
    ([, a]) => a != null
  )
), H = (i) => (a) => {
  var n, u;
  const r = {
    ...i.defaultVariants,
    ...W(a || {})
  }, s = i.classes ? [i.classes] : [];
  for (const c in r) {
    const f = r[c], M = (u = (n = i.variants) == null ? void 0 : n[c]) == null ? void 0 : u[f];
    M && s.push(M);
  }
  const t = i.compoundVariants || [];
  for (let c = 0; c < t.length; c += 1) {
    const f = t[c];
    Object.keys(f).filter((y) => y !== "classes").every((y) => {
      const T = f[y];
      return T && Array.isArray(T) ? (f == null ? void 0 : f[y]).includes(r[y]) : f[y] === r[y];
    }) && f.classes && s.push(f.classes);
  }
  const l = {};
  return s.forEach((c) => {
    Object.entries(c).forEach(([f, M]) => {
      M && (l[f] = [l[f], M].filter(Boolean).join(" "));
    });
  }, {}), l;
}, Z = {
  "arrow-down": {
    path: "M174.6 472.6c4.5 4.7 10.8 7.4 17.4 7.4s12.8-2.7 17.4-7.4l168-176c9.2-9.6 8.8-24.8-.8-33.9s-24.8-8.8-33.9 .8L216 396.1 216 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 340.1L41.4 263.4c-9.2-9.6-24.3-9.9-33.9-.8s-9.9 24.3-.8 33.9l168 176z",
    viewBox: "0 0 384 512"
  },
  "arrow-down-to-bracket": {
    path: "M369 217L241 345c-9.4 9.4-24.6 9.4-33.9 0L79 217c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87V24c0-13.3 10.7-24 24-24s24 10.7 24 24V270.1l87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM48 344v80c0 22.1 17.9 40 40 40H360c22.1 0 40-17.9 40-40V344c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 48.6-39.4 88-88 88H88c-48.6 0-88-39.4-88-88V344c0-13.3 10.7-24 24-24s24 10.7 24 24z",
    viewBox: "0 0 448 512"
  },
  "arrow-left": {
    path: "M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z",
    viewBox: "0 0 448 512"
  },
  "arrow-right": {
    path: "M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z",
    viewBox: "0 0 448 512"
  },
  "arrow-rotate-right": {
    path: "M456 224c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v80.1l-20-23.5C371 63.4 309.1 32 240 32C116.3 32 16 132.3 16 256s100.3 224 224 224c50.4 0 97-16.7 134.4-44.8c10.6-8 12.7-23 4.8-33.6s-23-12.7-33.6-4.8C316.2 418.9 279.7 432 240 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c54.3 0 102.9 24.6 135.2 63.4l.1 .2 0 0L402.9 176H312c-13.3 0-24 10.7-24 24s10.7 24 24 24H456z",
    viewBox: "0 0 512 512"
  },
  "arrow-up": {
    path: "M209.4 39.4C204.8 34.7 198.6 32 192 32s-12.8 2.7-17.4 7.4l-168 176c-9.2 9.6-8.8 24.8 .8 33.9s24.8 8.8 33.9-.8L168 115.9V456c0 13.3 10.7 24 24 24s24-10.7 24-24V115.9L342.6 248.6c9.2 9.6 24.3 9.9 33.9 .8s9.9-24.3 .8-33.9l-168-176z",
    viewBox: "0 0 384 512"
  },
  "arrow-up-from-bracket": {
    path: "M241 7c-9.4-9.4-24.6-9.4-33.9 0L79 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87V328c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9l87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zM48 344c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V344c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V344z",
    viewBox: "0 0 448 512"
  },
  "arrow-up-right-from-square": {
    path: "M304 24c0 13.3 10.7 24 24 24H430.1L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223V184c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z",
    viewBox: "0 0 512 512"
  },
  "arrows-maximize": {
    path: "M296 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h70.1L224 222.1 81.9 80H152c13.3 0 24-10.7 24-24s-10.7-24-24-24H24C10.7 32 0 42.7 0 56V184c0 13.3 10.7 24 24 24s24-10.7 24-24V113.9L190.1 256 48 398.1V328c0-13.3-10.7-24-24-24s-24 10.7-24 24V456c0 13.3 10.7 24 24 24H152c13.3 0 24-10.7 24-24s-10.7-24-24-24H81.9L224 289.9 366.1 432H296c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24s-24 10.7-24 24v70.1L257.9 256 400 113.9V184c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24H296z",
    viewBox: "0 0 448 512"
  },
  barcode: {
    path: "M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zm112 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zM464 56V456c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24s-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z",
    viewBox: "0 0 512 512"
  },
  bars: {
    path: "M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24z",
    viewBox: "0 0 448 512"
  },
  book: {
    path: "M0 88C0 39.4 39.4 0 88 0H392c30.9 0 56 25.1 56 56V344c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H392c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88C65.9 48 48 65.9 48 88V358.7zM152 112H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z",
    viewBox: "0 0 448 512"
  },
  "bullseye-pointer": {
    path: "M256 464c114.9 0 208-93.1 208-208s-93.1-208-208-208S48 141.1 48 256c0 5.5 .2 10.9 .6 16.3L1.8 286.1C.6 276.2 0 266.2 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-10.2 0-20.2-.6-30.1-1.8l13.8-46.9c5.4 .4 10.8 .6 16.3 .6zm-2.4-48l14.3-48.6C324.2 361.4 368 313.8 368 256c0-61.9-50.1-112-112-112c-57.8 0-105.4 43.8-111.4 100.1L96 258.4c0-.8 0-1.6 0-2.4c0-88.4 71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160c-.8 0-1.6 0-2.4 0zM39 308.5l204.8-60.2c12.2-3.6 23.4 7.7 19.9 19.9L203.5 473c-4.1 13.9-23.2 15.6-29.7 2.6l-28.7-57.3c-.7-1.3-1.5-2.6-2.5-3.7l-88 88c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l88-88c-1.1-1-2.3-1.9-3.7-2.5L36.4 338.2c-13-6.5-11.3-25.6 2.6-29.7z",
    viewBox: "0 0 512 512"
  },
  calendar: {
    path: "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z",
    viewBox: "0 0 448 512"
  },
  "calendar-clock": {
    path: "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48H432 400 288 48V448c0 8.8 7.2 16 16 16H284.5c12.3 18.8 28 35.1 46.3 48H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z",
    viewBox: "0 0 576 512"
  },
  check: {
    path: "M440.1 103C450.3 112.4 450.3 127.6 440.1 136.1L176.1 400.1C167.6 410.3 152.4 410.3 143 400.1L7.029 264.1C-2.343 255.6-2.343 240.4 7.029 231C16.4 221.7 31.6 221.7 40.97 231L160 350.1L407 103C416.4 93.66 431.6 93.66 440.1 103V103z",
    viewBox: "0 0 448 512"
  },
  "chevron-down": {
    path: "M199 401c9.4 9.4 24.6 9.4 33.9 0L425 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L41 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L199 401z",
    viewBox: "0 0 448 512"
  },
  "chevron-left": {
    path: "M7 239c-9.4 9.4-9.4 24.6 0 33.9L199 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L57.9 256 233 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239z",
    viewBox: "0 0 320 512"
  },
  "chevron-right": {
    path: "M297 239c9.4 9.4 9.4 24.6 0 33.9L105 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L71 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L297 239z",
    viewBox: "0 0 320 512"
  },
  "chevron-up": {
    path: "M199 111c9.4-9.4 24.6-9.4 33.9 0L425 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L41 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L199 111z",
    viewBox: "0 0 448 512"
  },
  "chevrons-down": {
    path: "M199 465c9.4 9.4 24.6 9.4 33.9 0L425 273c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L199 465zM7 81L199 273c9.4 9.4 24.6 9.4 33.9 0L425 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L41 47C31.6 37.7 16.4 37.7 7 47S-2.3 71.6 7 81z",
    viewBox: "0 0 448 512"
  },
  "chevrons-left": {
    path: "M7 239c-9.4 9.4-9.4 24.6 0 33.9L199 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L57.9 256 233 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239zM391 47L199 239c-9.4 9.4-9.4 24.6 0 33.9L391 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-175-175L425 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z",
    viewBox: "0 0 448 512"
  },
  "chevrons-right": {
    path: "M425 239c9.4 9.4 9.4 24.6 0 33.9L233 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L199 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L425 239zM41 47L233 239c9.4 9.4 9.4 24.6 0 33.9L41 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L7 81C-2.3 71.6-2.3 56.4 7 47s24.6-9.4 33.9 0z",
    viewBox: "0 0 448 512"
  },
  "chevrons-up": {
    path: "M233 47c-9.4-9.4-24.6-9.4-33.9 0L7 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l175-175L391 273c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L233 47zM425 431L233 239c-9.4-9.4-24.6-9.4-33.9 0L7 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l175-175L391 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z",
    viewBox: "0 0 448 512"
  },
  clock: {
    path: "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z",
    viewBox: "0 0 512 512"
  },
  clone: {
    path: "M64 464H288c8.8 0 16-7.2 16-16V384h48v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64v48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM224 304H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16V288c0 8.8 7.2 16 16 16zm-64-16V64c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64z",
    viewBox: "0 0 512 512"
  },
  "cloud-arrow-down": {
    path: "M223 312.1C213.7 303.6 213.7 288.4 223 279C232.4 269.7 247.6 269.7 256.1 279L296 318.1V184C296 170.7 306.7 160 320 160C333.3 160 344 170.7 344 184V318.1L383 279C392.4 269.7 407.6 269.7 416.1 279C426.3 288.4 426.3 303.6 416.1 312.1L336.1 392.1C327.6 402.3 312.4 402.3 303 392.1L223 312.1zM144 480C64.47 480 0 415.5 0 336C0 273.3 40.07 219.1 96 200.2V200C96 107.2 171.2 32 264 32C314.9 32 360.4 54.6 391.3 90.31C406.2 83.68 422.6 80 440 80C506.3 80 560 133.7 560 200C560 206.6 559.5 213 558.5 219.3C606.5 240.3 640 288.3 640 344C640 416.4 583.4 475.6 512 479.8V480H144zM264 80C197.7 80 144 133.7 144 200L144 234.1L111.1 245.5C74.64 258.7 48 294.3 48 336C48 389 90.98 432 144 432H506.6L509.2 431.8C555.4 429.2 592 390.8 592 344C592 308 570.4 276.9 539.2 263.3L505.1 248.4L511.1 211.7C511.7 207.9 512 204 512 200C512 160.2 479.8 128 440 128C429.5 128 419.6 130.2 410.8 134.2L378.2 148.7L354.9 121.7C332.8 96.08 300.3 80 263.1 80L264 80z",
    viewBox: "0 0 640 512"
  },
  "cloud-arrow-up": {
    path: "M303 175C312.4 165.7 327.6 165.7 336.1 175L416.1 255C426.3 264.4 426.3 279.6 416.1 288.1C407.6 298.3 392.4 298.3 383 288.1L344 249.9V384C344 397.3 333.3 408 320 408C306.7 408 296 397.3 296 384V249.9L256.1 288.1C247.6 298.3 232.4 298.3 223 288.1C213.7 279.6 213.7 264.4 223 255L303 175zM144 480C64.47 480 0 415.5 0 336C0 273.3 40.07 219.1 96 200.2V200C96 107.2 171.2 32 264 32C314.9 32 360.4 54.6 391.3 90.31C406.2 83.68 422.6 80 440 80C506.3 80 560 133.7 560 200C560 206.6 559.5 213 558.5 219.3C606.5 240.3 640 288.3 640 344C640 416.4 583.4 475.6 512 479.8V480H144zM264 80C197.7 80 144 133.7 144 200L144 234.1L111.1 245.5C74.64 258.7 48 294.3 48 336C48 389 90.98 432 144 432H506.6L509.2 431.8C555.4 429.2 592 390.8 592 344C592 308 570.4 276.9 539.2 263.3L505.1 248.4L511.1 211.7C511.7 207.9 512 204 512 200C512 160.2 479.8 128 440 128C429.5 128 419.6 130.2 410.8 134.2L378.2 148.7L354.9 121.7C332.8 96.08 300.3 80 263.1 80L264 80z",
    viewBox: "0 0 640 512"
  },
  "cloud-check": {
    path: "M307.8 371.8C296.9 382.7 279.1 382.7 268.2 371.8L204.2 307.8C193.3 296.9 193.3 279.1 204.2 268.2C215.1 257.3 232.9 257.3 243.8 268.2L288 312.4L396.2 204.2C407.1 193.3 424.9 193.3 435.8 204.2C446.7 215.1 446.7 232.9 435.8 243.8L307.8 371.8zM144 480C64.47 480 0 415.5 0 336C0 273.3 40.07 219.1 96 200.2V200C96 107.2 171.2 32 264 32C314.9 32 360.4 54.6 391.3 90.31C406.2 83.68 422.6 80 440 80C506.3 80 560 133.7 560 200C560 206.6 559.5 213 558.5 219.3C606.5 240.3 640 288.3 640 344C640 416.4 583.4 475.6 512 479.8V480H144zM264 80C197.7 80 144 133.7 144 200L144 234.1L111.1 245.5C74.64 258.7 48 294.3 48 336C48 389 90.98 432 144 432H506.6L509.2 431.8C555.4 429.2 592 390.8 592 344C592 308 570.4 276.9 539.2 263.3L505.1 248.4L511.1 211.7C511.7 207.9 512 204 512 200C512 160.2 479.8 128 440 128C429.5 128 419.6 130.2 410.8 134.2L378.2 148.7L354.9 121.7C332.8 96.08 300.3 80 263.1 80L264 80z",
    viewBox: "0 0 640 512"
  },
  code: {
    path: "M414.9 31.11L270.9 495.1C266.1 507.8 253.5 514.8 240.9 510.9C228.2 506.1 221.1 493.5 225.1 480.9L369.1 16.89C373 4.226 386.5-2.852 399.1 1.077C411.8 5.006 418.9 18.45 414.9 31.11V31.11zM504.4 118.5L632.4 238.5C637.3 243 640 249.4 640 255.1C640 262.6 637.3 268.1 632.4 273.5L504.4 393.5C494.7 402.6 479.6 402.1 470.5 392.4C461.4 382.7 461.9 367.6 471.6 358.5L580.9 255.1L471.6 153.5C461.9 144.4 461.4 129.3 470.5 119.6C479.6 109.9 494.7 109.4 504.4 118.5V118.5zM168.4 153.5L59.09 255.1L168.4 358.5C178.1 367.6 178.6 382.7 169.5 392.4C160.4 402.1 145.3 402.6 135.6 393.5L7.585 273.5C2.746 268.1 0 262.6 0 255.1C0 249.4 2.746 243 7.585 238.5L135.6 118.5C145.3 109.4 160.4 109.9 169.5 119.6C178.6 129.3 178.1 144.4 168.4 153.5V153.5z",
    viewBox: "0 0 640 512"
  },
  "compact-disc": {
    path: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM241.8 128.8c8.8-1 15.1-8.9 14.1-17.7s-8.9-15.1-17.7-14.1C164.1 105.2 105.2 164.1 97 238.2c-1 8.8 5.4 16.7 14.1 17.7s16.7-5.4 17.7-14.1c6.6-59.3 53.7-106.4 113-113z",
    viewBox: "0 0 512 512"
  },
  desktop: {
    path: "M512 48H64c-8.8 0-16 7.2-16 16V256H528V64c0-8.8-7.2-16-16-16zm64 208v48 48c0 35.3-28.7 64-64 64H364.3l8 48H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H352 224 152c-13.3 0-24-10.7-24-24s10.7-24 24-24h51.7l8-48H64c-35.3 0-64-28.7-64-64V304 256 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V256zM48 304v48c0 8.8 7.2 16 16 16H239.5c.3 0 .6 0 .8 0h95.2c.3 0 .6 0 .8 0H512c8.8 0 16-7.2 16-16V304H48zM252.3 464h71.3l-8-48H260.3l-8 48z",
    viewBox: "0 0 576 512"
  },
  "ellipsis-vertical": {
    path: "M48 464a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-160a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM0 96a48 48 0 1 1 96 0A48 48 0 1 1 0 96z",
    viewBox: "0 0 128 512"
  },
  folder: {
    path: "M0 96C0 60.7 28.7 32 64 32H196.1c19.1 0 37.4 7.6 50.9 21.1L289.9 96H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H286.6c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7H64z",
    viewBox: "0 0 512 512"
  },
  "folder-open": {
    path: "M384 480h48c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224H144c-11.4 0-21.9 6-27.6 15.9L48 357.1V96c0-8.8 7.2-16 16-16H181.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8H416c8.8 0 16 7.2 16 16v32h48V160c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H87.7 384z",
    viewBox: "0 0 576 512"
  },
  gear: {
    path: "M208.1 51.4C220.3 49.2 233 48 246 48s25.7 1.2 37.9 3.4l8.5 35.1c4.1 17 15.6 29.8 28.9 37.4l1.4 .8c13.2 7.7 30.1 11.3 46.9 6.4l34.6-10.2c7.4 8.7 14.2 18 20.1 27.8l4 6.9c5.4 9.8 10.1 20.2 13.9 30.9l-26.2 24.9c-12.7 12-18 28.4-17.9 43.7l0 .8 0 .8c-.1 15.3 5.3 31.6 17.9 43.7l26.2 24.9c-3.8 10.7-8.5 21.1-13.9 30.9l-4 6.9c-5.9 9.8-12.7 19.1-20.1 27.8l-34.6-10.2c-16.8-5-33.7-1.4-46.9 6.4l-1.4 .8c-13.2 7.6-24.8 20.4-28.9 37.4l-8.5 35.1c-12.3 2.3-25 3.4-37.9 3.4s-25.7-1.2-37.9-3.4l-8.5-35.1c-4.1-17-15.6-29.8-28.9-37.4l-1.4-.8c-13.2-7.7-30.1-11.3-46.9-6.4L87.9 391.1c-7.4-8.7-14.2-18-20.1-27.8l-4-7c-5.4-9.8-10.1-20.2-13.9-30.9l26.2-24.9c12.7-12 18-28.4 17.9-43.7l0-.8 0-.8c.1-15.3-5.3-31.6-17.9-43.7L49.9 186.6c3.8-10.7 8.5-21.1 13.9-30.9l4-6.9c5.9-9.8 12.7-19.1 20.1-27.8l34.6 10.2c16.8 5 33.7 1.4 46.9-6.4l1.4-.8c13.2-7.6 24.8-20.4 28.9-37.4l8.5-35.1zM246 0c-17 0-33.6 1.7-49.8 4.8c-7.9 1.5-21.8 6.1-29.4 20.1c-2 3.7-3.6 7.6-4.6 11.8l-9.3 38.5c-.5 2-2.2 4.8-6 7c-.6 .4-1.2 .7-1.9 1.1c-3.8 2.2-7 2.3-9.1 1.7L98 73.8c-4-1.2-8.1-1.8-12.2-1.9c-16.1-.5-27 9.4-32.3 15.4c-10 11.4-19 23.8-26.9 36.9l0 0-.2 .4-4.2 7.3 0 0-.2 .4c-7.3 13.1-13.4 26.9-18.3 41.3C1 181.1-2 195.3 6.2 208.9c2.2 3.6 4.9 7 8 10L43 246.3c1.5 1.5 3 4.3 3 8.7l0 1.1 0 1.1c0 4.3-1.5 7.2-3 8.7L14.2 293.1c-3.1 3-5.8 6.4-8 10C-2 316.7 1 330.9 3.6 338.4c4.9 14.4 11 28.2 18.3 41.3l0 0 .2 .4 4.3 7.4 0 0 .2 .4c7.9 13.1 16.9 25.4 26.9 36.8c5.3 6 16.3 15.9 32.3 15.4c4.1-.1 8.2-.8 12.2-1.9L136 427c2-.6 5.3-.5 9.1 1.7c.6 .4 1.2 .7 1.9 1.1c3.8 2.2 5.5 4.9 6 7l9.3 38.5c1 4.2 2.6 8.2 4.6 11.8c7.7 14 21.6 18.5 29.4 20.1c16.1 3.2 32.8 4.8 49.8 4.8s33.6-1.7 49.8-4.8c7.9-1.5 21.8-6.1 29.4-20.1c2-3.7 3.6-7.6 4.6-11.8l9.3-38.5c.5-2 2.2-4.8 6-7c.6-.4 1.2-.7 1.9-1.1c3.8-2.2 7-2.3 9.1-1.7l38 11.2c4 1.2 8.1 1.8 12.2 1.9c16.1 .5 27-9.4 32.3-15.4c10-11.4 19-23.8 26.9-36.9l0 0 .2-.4 4.2-7.3 0 0 .2-.4c7.3-13.1 13.4-26.9 18.3-41.3c2.6-7.6 5.6-21.8-2.7-35.4c-2.2-3.6-4.9-7-8-10L449 265.7c-1.5-1.5-3-4.3-3-8.7l0-1.1 0-1.1c0-4.3 1.5-7.2 3-8.7l28.7-27.3c3.1-3 5.8-6.4 8-10c8.2-13.6 5.2-27.8 2.7-35.4c-4.9-14.4-11-28.2-18.3-41.3l0 0-.2-.4-4.2-7.3 0 0-.2-.4c-7.9-13.1-16.9-25.4-26.9-36.9c-5.3-6-16.3-15.9-32.3-15.4c-4.1 .1-8.2 .8-12.2 1.9L356 85c-2 .6-5.3 .5-9.1-1.7c-.6-.4-1.2-.7-1.9-1.1c-3.8-2.2-5.5-4.9-6-7l-9.3-38.5c-1-4.2-2.6-8.2-4.6-11.8c-7.7-14-21.6-18.5-29.4-20.1C279.6 1.7 263 0 246 0zM198 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm144 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z",
    viewBox: "0 0 512 512"
  },
  "grip-dots-vertical": {
    path: "M32 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM64 416A32 32 0 1 0 0 416a32 32 0 1 0 64 0zm96-288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM160 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64z",
    viewBox: "0 0 192 512"
  },
  hashtag: {
    path: "M188.7 32.5c13 2.6 21.4 15.2 18.8 28.2L192.5 136h111l16.9-84.7c2.6-13 15.2-21.4 28.2-18.8s21.4 15.2 18.8 28.2L352.5 136H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H342.9L314.1 328H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H304.5l-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L255.5 376h-111l-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L95.5 376H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h81.1l28.8-144H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h87.5l16.9-84.7c2.6-13 15.2-21.4 28.2-18.8zM182.9 184L154.1 328h111l28.8-144h-111z",
    viewBox: "0 0 448 512"
  },
  "input-numeric": {
    path: "M576 112c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H576zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm40 120c0 13.3 10.7 24 24 24h8v96H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H184V184c0-13.3-10.7-24-24-24H128c-13.3 0-24 10.7-24 24zm190.6 30.4c5.7-8 17.5-8.6 24-1.2c5.2 5.9 5 14.7-.3 20.5l-72 78c-6.5 7-8.2 17.2-4.3 25.9s12.5 14.4 22 14.4h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H318.8l34.8-37.7c22-23.8 22.4-60.3 1.1-84.7c-26.9-30.7-75.4-28.4-99.2 4.9l-11.1 15.6c-7.7 10.8-5.2 25.8 5.6 33.5s25.8 5.2 33.5-5.6l11.1-15.6z",
    viewBox: "0 0 640 512"
  },
  "input-pipe": {
    path: "M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H576c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm144 56V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z",
    viewBox: "0 0 640 512"
  },
  "input-text": {
    path: "M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H576c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128C0 92.7 28.7 64 64 64H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm184 32c9.5 0 18.1 5.6 21.9 14.3l64 144c5.4 12.1-.1 26.3-12.2 31.7s-26.3-.1-31.7-12.2l-4.3-9.7H146.3l-4.3 9.7c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l64-144c3.9-8.7 12.4-14.3 21.9-14.3zm0 83.1L167.6 280h32.8L184 243.1zM304 184c0-13.3 10.7-24 24-24h52c33.1 0 60 26.9 60 60c0 9.2-2.1 17.9-5.8 25.7c13.3 11 21.8 27.6 21.8 46.3c0 33.1-26.9 60-60 60H328c-13.3 0-24-10.7-24-24v-8V256 192v-8zm48 24v24h28c6.6 0 12-5.4 12-12s-5.4-12-12-12H352zm0 96h44c6.6 0 12-5.4 12-12s-5.4-12-12-12H380 352v24z",
    viewBox: "0 0 640 512"
  },
  language: {
    path: "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H272h32 16H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H320 304 272 64zm512 48c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H320V112H576zM178.3 175.9l64 144c4.5 10.1-.1 21.9-10.2 26.4s-21.9-.1-26.4-10.2L196.8 316H123.2l-8.9 20.1c-4.5 10.1-16.3 14.6-26.4 10.2s-14.6-16.3-10.2-26.4l64-144c3.2-7.2 10.4-11.9 18.3-11.9s15.1 4.7 18.3 11.9zM179 276l-19-42.8L141 276h38zM456 164c-11 0-20 9-20 20v4H384c-11 0-20 9-20 20s9 20 20 20h72 35.1c-7.3 16.7-17.4 31.9-29.8 45l-.5-.5-14.6-14.6c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3L430 298.3c-5.9 3.6-12.1 6.9-18.5 9.8l-3.6 1.6c-10.1 4.5-14.6 16.3-10.2 26.4s16.3 14.6 26.4 10.2l3.6-1.6c12-5.3 23.4-11.8 34-19.4c4.3 3 8.6 5.8 13.1 8.5l18.9 11.3c9.5 5.7 21.8 2.6 27.4-6.9s2.6-21.8-6.9-27.4l-18.9-11.3c-.9-.5-1.8-1.1-2.7-1.6c17.2-18.8 30.7-40.9 39.6-65.4L534 228h2c11 0 20-9 20-20s-9-20-20-20H520 476v-4c0-11-9-20-20-20z",
    viewBox: "0 0 640 512"
  },
  "laptop-mobile": {
    path: "M128 48H448c8.8 0 16 7.2 16 16V96h48V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64V320H16c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48H352V320H112V64c0-8.8 7.2-16 16-16zM384 176V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48zm48 0H592V464H432V176z",
    viewBox: "0 0 640 512"
  },
  link: {
    path: "M563.3 267.2c56.2-56.2 56.2-147.3 0-203.5C509.8 10.2 423.9 7.3 366.9 57.2l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6L416.1 346.6c-37.4 37.4-98.2 37.4-135.6 0c-35.7-35.7-37.6-92.9-4.4-130.9l4.7-5.4c8.7-10 7.7-25.1-2.3-33.9s-25.1-7.7-33.9 2.3l-4.7 5.4c-49.8 57-46.9 142.9 6.6 196.4c56.2 56.2 147.3 56.2 203.5 0L563.3 267.2zM42.7 244.8c-56.2 56.2-56.2 147.3 0 203.5c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6L190 165.4c37.4-37.4 98.1-37.4 135.6 0c35.7 35.7 37.6 92.9 4.4 130.9l-5.4 6.1c-8.7 10-7.7 25.1 2.3 33.9s25.1 7.7 33.9-2.3l5.4-6.1c49.9-57 47-142.9-6.5-196.5c-56.2-56.2-147.3-56.2-203.5 0L42.7 244.8z",
    viewBox: "0 0 640 512"
  },
  "list-radio": {
    path: "M64 32a64 64 0 1 0 0 128A64 64 0 1 0 64 32zM184 72c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zM64 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-88a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM40 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0z",
    viewBox: "0 0 512 512"
  },
  "magnifying-glass": {
    path: "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z",
    viewBox: "0 0 512 512"
  },
  "message-text": {
    path: "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM168 112c-13.3 0-24 10.7-24 24s10.7 24 24 24h64V296c0 13.3 10.7 24 24 24s24-10.7 24-24V160h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 168z",
    viewBox: "0 0 512 512"
  },
  microphone: {
    path: "M224 96V256c0 26.5-21.5 48-48 48s-48-21.5-48-48V96c0-26.5 21.5-48 48-48s48 21.5 48 48zM80 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96S80 43 80 96zM48 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H104c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H200V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z",
    viewBox: "0 0 384 512"
  },
  minus: {
    path: "M416 256c0 13.3-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z",
    viewBox: "0 0 448 512"
  },
  mobile: {
    path: "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM144 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z",
    viewBox: "0 0 384 512"
  },
  moon: {
    path: "M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0c-.1 0-.2 0-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z",
    viewBox: "0 0 384 512"
  },
  "object-group": {
    path: "M16 115.8C6.2 107 0 94.2 0 80C0 53.5 21.5 32 48 32c14.2 0 27 6.2 35.8 16H428.2c8.8-9.8 21.6-16 35.8-16c26.5 0 48 21.5 48 48c0 14.2-6.2 27-16 35.8V396.2c9.8 8.8 16 21.6 16 35.8c0 26.5-21.5 48-48 48c-14.2 0-27-6.2-35.8-16H83.8C75 473.8 62.2 480 48 480c-26.5 0-48-21.5-48-48c0-14.2 6.2-27 16-35.8V115.8zM93.3 96c-4.8 13.6-15.6 24.4-29.3 29.3V386.7c13.6 4.8 24.4 15.6 29.3 29.3H418.7c4.8-13.6 15.6-24.4 29.3-29.3V125.3c-13.6-4.8-24.4-15.6-29.3-29.3H93.3zM96 160c0-17.7 14.3-32 32-32H256c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160zM224 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V320z",
    viewBox: "0 0 512 512"
  },
  paperclip: {
    path: "M370 73c-26-26-68.1-26-94.1 0L84 265C40.3 308.6 40.3 379.4 84 423s114.4 43.6 158.1 0L394 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L276 457c-62.4 62.4-163.5 62.4-225.9 0S-12.4 293.4 50 231L242 39C286.7-5.7 359.2-5.7 404 39s44.7 117.2 0 161.9L220.2 384.7c-31.6 31.6-83.6 28.7-111.5-6.2c-23.8-29.8-21.5-72.8 5.5-99.8L266 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L148.2 312.7c-9.7 9.7-10.6 25.1-2 35.8c10 12.5 28.7 13.6 40 2.2L370 167c26-26 26-68.1 0-94.1z",
    viewBox: "0 0 448 512"
  },
  "pen-field": {
    path: "M569.2 59.1L581.1 71c9.4 9.4 9.4 24.6 0 33.9L560 126.1 514.3 80.4l20.8-21.1c9.4-9.5 24.6-9.5 34.1-.1zM359.9 236.8L480.6 114.5 526.1 160 404.6 281.6c-3.3 3.3-7.5 5.6-12 6.5L343 298.5l10.4-49.7c.9-4.5 3.2-8.7 6.4-11.9zM501 25.5L325.7 203.1c-9.7 9.8-16.4 22.3-19.2 35.8l-18 85.7c-1.7 7.9 .8 16.2 6.5 21.9s14 8.2 21.9 6.5l85.5-17.9c13.7-2.9 26.2-9.7 36.1-19.6L615.1 138.9c28.1-28.1 28.1-73.7 0-101.8L603.1 25.2C574.9-3.1 529-2.9 501 25.5zM72 128c-39.8 0-72 32.2-72 72V440c0 39.8 32.2 72 72 72H504c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V200c0-13.3 10.7-24 24-24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H72zm56 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z",
    viewBox: "0 0 640 512"
  },
  pencil: {
    path: "M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c10.4-3 20.1-8 28.6-14.5l.3 .2 .5-.8c1.4-1.1 2.7-2.2 4-3.3c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-2.5 2.5-4.9 5.2-7.1 8l-.8 .5 .2 .3c-6.5 8.5-11.4 18.2-14.5 28.6zM383 191L197.4 376.6l-49.6-12.4-12.4-49.6L321 129 383 191zM97 358.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1L97 358.9zM315.3 218.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z",
    viewBox: "0 0 512 512"
  },
  plus: {
    path: "M232 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H184V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V72z",
    viewBox: "0 0 448 512"
  },
  share: {
    path: "M288 240H192c-66.2 0-122 44.7-138.8 105.5C49.9 333.1 48 319.3 48 304c0-70.7 57.3-128 128-128H288h24c13.3 0 24-10.7 24-24V128 99.9L456.1 208 336 316.1V288 264c0-13.3-10.7-24-24-24H288zm0 48v48 16c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4s-19 16.6-19 29.2V80v48H240 176C78.8 128 0 206.8 0 304c0 78 38.6 126.2 68.7 152.1c4.1 3.5 8.1 6.6 11.7 9.3c3.2 2.4 6.2 4.4 8.9 6.2c4.5 3 8.3 5.1 10.8 6.5c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-6.8-3.6-13.2-8.3-18.1c-.5-.5-.9-.9-1.4-1.4c-2.4-2.3-5.1-5.1-7.7-8.6c-1.7-2.3-3.4-5-5-7.9c-5.3-9.7-9.5-22.9-9.5-40.2c0-53 43-96 96-96h48 48z",
    viewBox: "0 0 512 512"
  },
  sidebar: {
    path: "M224 80V432H448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H224zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88zM64 312c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H88c-13.3 0-24 10.7-24 24z",
    viewBox: "0 0 512 512"
  },
  "sidebar-flip": {
    path: "M288 80V432H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H288zM512 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96zm-64 24c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24zm-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h48zm24 120c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24z",
    viewBox: "0 0 512 512"
  },
  spinner: {
    path: "M288 32C288 49.67 273.7 64 256 64C238.3 64 224 49.67 224 32C224 14.33 238.3 0 256 0C273.7 0 288 14.33 288 32zM288 480C288 497.7 273.7 512 256 512C238.3 512 224 497.7 224 480C224 462.3 238.3 448 256 448C273.7 448 288 462.3 288 480zM480 224C497.7 224 512 238.3 512 256C512 273.7 497.7 288 480 288C462.3 288 448 273.7 448 256C448 238.3 462.3 224 480 224zM32 288C14.33 288 0 273.7 0 256C0 238.3 14.33 224 32 224C49.67 224 64 238.3 64 256C64 273.7 49.67 288 32 288zM74.98 391.8C87.48 379.3 107.7 379.3 120.2 391.8C132.7 404.3 132.7 424.5 120.2 437C107.7 449.5 87.48 449.5 74.98 437C62.48 424.5 62.48 404.3 74.98 391.8zM391.8 437C379.3 424.5 379.3 404.3 391.8 391.8C404.3 379.3 424.5 379.3 437 391.8C449.5 404.3 449.5 424.5 437 437C424.5 449.5 404.3 449.5 391.8 437zM120.2 74.98C132.7 87.48 132.7 107.7 120.2 120.2C107.7 132.7 87.48 132.7 74.98 120.2C62.48 107.7 62.48 87.48 74.98 74.98C87.48 62.49 107.7 62.49 120.2 74.98z",
    viewBox: "0 0 512 512"
  },
  "square-check": {
    path: "M211.8 339.8C200.9 350.7 183.1 350.7 172.2 339.8L108.2 275.8C97.27 264.9 97.27 247.1 108.2 236.2C119.1 225.3 136.9 225.3 147.8 236.2L192 280.4L300.2 172.2C311.1 161.3 328.9 161.3 339.8 172.2C350.7 183.1 350.7 200.9 339.8 211.8L211.8 339.8zM0 96C0 60.65 28.65 32 64 32H384C419.3 32 448 60.65 448 96V416C448 451.3 419.3 480 384 480H64C28.65 480 0 451.3 0 416V96zM48 96V416C48 424.8 55.16 432 64 432H384C392.8 432 400 424.8 400 416V96C400 87.16 392.8 80 384 80H64C55.16 80 48 87.16 48 96z",
    viewBox: "0 0 448 512"
  },
  "sun-bright": {
    path: "M280 24V88c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zm157 84.9l-45.3 45.3c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L403.1 75c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM108.9 75l45.3 45.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L75 108.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM24 232H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm400 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H424c-13.3 0-24-10.7-24-24s10.7-24 24-24zM154.2 391.8L108.9 437c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l45.3-45.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm237.6-33.9L437 403.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-45.3-45.3c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM280 424v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V424c0-13.3 10.7-24 24-24s24 10.7 24 24zm40-168a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-176 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z",
    viewBox: "0 0 512 512"
  },
  "table-layout": {
    path: "M448 80c8.8 0 16 7.2 16 16v64H48V96c0-8.8 7.2-16 16-16H448zM48 416V208h96V432H64c-8.8 0-16-7.2-16-16zm144 16V208H464V416c0 8.8-7.2 16-16 16H192zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z",
    viewBox: "0 0 512 512"
  },
  tablet: {
    path: "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16z",
    viewBox: "0 0 448 512"
  },
  text: {
    path: "M48 80v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V72C0 49.9 17.9 32 40 32H408c22.1 0 40 17.9 40 40v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H248l0 352h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h48l0-352H48z",
    viewBox: "0 0 448 512"
  },
  "text-size": {
    path: "M48 128V80H168l0 352H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H216l0-352H336v48c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72v56c0 13.3 10.7 24 24 24s24-10.7 24-24zM360 296V272h96l0 160H424c-13.3 0-24 10.7-24 24s10.7 24 24 24H536c13.3 0 24-10.7 24-24s-10.7-24-24-24H504l0-160h88v24c0 13.3 10.7 24 24 24s24-10.7 24-24V264c0-22.1-17.9-40-40-40H352c-22.1 0-40 17.9-40 40v32c0 13.3 10.7 24 24 24s24-10.7 24-24z",
    viewBox: "0 0 640 512"
  },
  trash: {
    path: "M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z",
    viewBox: "0 0 448 512"
  },
  "triangle-exclamation": {
    path: "M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5H62.5c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480h387c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3zM288 368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-184c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184z",
    viewBox: "0 0 512 512"
  },
  user: {
    path: "M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z",
    viewBox: "0 0 448 512"
  },
  xmark: {
    path: "M313 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L41 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L7 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L279 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L313 137z",
    viewBox: "0 0 320 512"
  }
}, e4 = H({
  classes: {
    svg: "fill-current"
  },
  defaultVariants: {
    size: "md"
  },
  variants: {
    size: {
      sm: {
        svg: "h-3 w-3"
      },
      md: {
        svg: "h-4 w-4"
      },
      lg: {
        svg: "h-5 w-5"
      }
    }
  }
}), t4 = ["viewBox"], a4 = ["d"], s4 = {
  name: "VtIcon"
}, w = /* @__PURE__ */ g({
  ...s4,
  props: {
    name: {},
    size: {}
  },
  setup(i) {
    const a = i, r = d(() => Z[a.name]), s = d(() => e4({ size: a.size }));
    return (t, l) => r.value ? (o(), v("svg", {
      key: 0,
      viewBox: r.value.viewBox,
      "aria-hidden": "true",
      class: e(s.value.svg)
    }, [
      p("path", {
        d: r.value.path
      }, null, 8, a4)
    ], 10, t4)) : V("", !0);
  }
}), l4 = H({
  classes: {
    container: "mb-4 flex flex-wrap items-center gap-3 gap-y-4 rounded-lg p-4 dark:bg-neutral-800",
    icon: "flex-none",
    content: "flex-1 text-sm font-medium",
    closeAction: "-m-1.5 inline-flex h-8 w-8 flex-none items-center justify-center rounded-full p-1.5 focus:outline-none focus:ring-2 dark:bg-neutral-800 dark:hover:bg-neutral-700",
    closeActionIcon: "",
    actionsContainer: "flex w-full flex-1 basis-full justify-end gap-2",
    action: "-m-1.5 inline-flex flex-none items-center justify-center rounded-full px-4 py-1.5 font-semibold focus:outline-none focus:ring-2 dark:bg-neutral-800 dark:hover:bg-neutral-700"
  },
  variants: {
    intent: {
      warning: {
        container: "bg-warning-100 text-warning-800 dark:text-warning-300",
        closeAction: "bg-warning-100 text-warning-500 hover:bg-warning-200 focus:ring-warning-400 dark:text-warning-300"
      },
      danger: {
        container: "bg-danger-100 text-danger-800 dark:text-danger-300",
        closeAction: "bg-danger-100 text-danger-500 hover:bg-danger-200 focus:ring-danger-400 dark:text-danger-300"
      }
    }
  }
}), c4 = ["innerHTML"], r4 = ["onClick"], n4 = {
  name: "VtAlert"
}, j4 = /* @__PURE__ */ g({
  ...n4,
  props: {
    intent: {},
    text: { default: "" },
    htmlContent: { default: "" },
    actions: { default() {
      return [];
    } }
  },
  emits: ["close"],
  setup(i, { emit: a }) {
    const r = i, s = d(() => l4({ intent: r.intent })), t = N(!0), l = () => {
      t.value = !1, a("close");
    };
    return (n, u) => t.value ? (o(), v("div", {
      key: 0,
      class: e(s.value.container),
      role: "alert"
    }, [
      C(w, {
        name: "triangle-exclamation",
        size: "lg",
        class: e(s.value.icon)
      }, null, 8, ["class"]),
      n.htmlContent ? (o(), v("div", {
        key: 0,
        class: e(s.value.content),
        innerHTML: n.htmlContent
      }, null, 10, c4)) : (o(), v("div", {
        key: 1,
        class: e(s.value.content)
      }, x(n.text), 3)),
      p("button", {
        type: "button",
        class: e(s.value.closeAction),
        "aria-label": "Close",
        onClick: l
      }, [
        C(w, {
          name: "xmark",
          class: e(s.value.closeActionIcon)
        }, null, 8, ["class"])
      ], 2),
      n.actions.length ? (o(), v("div", {
        key: 2,
        class: e(s.value.actionsContainer)
      }, [
        (o(!0), v($, null, A(n.actions, (c) => (o(), v("button", {
          key: c.text,
          type: "button",
          class: e(s.value.action),
          onClick: c.onClick
        }, x(c.text), 11, r4))), 128))
      ], 2)) : V("", !0)
    ], 2)) : V("", !0);
  }
}), o4 = {
  name: "VtBreadcrumb"
}, D4 = /* @__PURE__ */ g({
  ...o4,
  setup(i) {
    const a = H({
      classes: {
        container: "",
        ul: "flex"
      }
    }), r = d(() => a());
    return (s, t) => (o(), v("nav", {
      class: e(r.value.container)
    }, [
      p("ul", {
        class: e(r.value.ul)
      }, [
        z(s.$slots, "default")
      ], 2)
    ], 2));
  }
}), i4 = {
  name: "VtMenuItem",
  inheritAttrs: !1
}, J = /* @__PURE__ */ g({
  ...i4,
  props: {
    text: {},
    supertext: { default: "" },
    subtext: { default: "" },
    active: { type: Boolean },
    tagName: { default: "button" }
  },
  setup(i) {
    const a = i, r = S(), s = H({
      classes: {
        action: "relative flex w-full flex-row items-center gap-4 px-6 py-3 ui-active:bg-primary-100 ui-active:dark:bg-neutral-800",
        main: "flex flex-1 flex-col items-start text-start after:absolute after:inset-0 after:cursor-pointer after:content-[''] focus-visible:outline-none focus-visible:after:border-4 focus-visible:after:border-primary-300 dark:focus-visible:after:border-neutral-600",
        start: "pointer-events-none relative",
        end: "pointer-events-none relative",
        supertext: "line-clamp-1 text-xs text-neutral-500 dark:text-neutral-300",
        text: "line-clamp-3 break-all text-base text-neutral-800 ui-active:text-primary-500 dark:text-neutral-50 ui-active:dark:text-primary-300",
        subtext: "text-sm text-neutral-500 dark:text-neutral-300"
      },
      defaultVariants: {
        active: !1
      },
      variants: {
        active: {
          true: {
            action: " hover:bg-primary-100 dark:bg-neutral-800 dark:hover:bg-neutral-800",
            text: "text-primary-500 dark:text-primary-300"
          },
          false: {
            action: " hover:bg-primary-100 dark:hover:bg-neutral-800"
          }
        }
      }
    }), t = d(() => s({ active: a.active })), l = d(() => a.tagName === "button" ? {
      type: "button",
      ...r
    } : r);
    return (n, u) => (o(), b(k(n.tagName), L(l.value, {
      class: t.value.action
    }), {
      default: m(() => [
        n.$slots.start ? (o(), v("div", {
          key: 0,
          class: e(t.value.start)
        }, [
          z(n.$slots, "start")
        ], 2)) : V("", !0),
        p("div", {
          class: e(t.value.main)
        }, [
          n.supertext ? (o(), v("div", {
            key: 0,
            class: e(t.value.supertext)
          }, x(n.supertext), 3)) : V("", !0),
          p("div", {
            class: e(t.value.text)
          }, x(n.text), 3),
          n.subtext ? (o(), v("div", {
            key: 1,
            class: e(t.value.subtext)
          }, x(n.subtext), 3)) : V("", !0),
          z(n.$slots, "default")
        ], 2),
        n.$slots.end ? (o(), v("div", {
          key: 1,
          class: e(t.value.end)
        }, [
          z(n.$slots, "end")
        ], 2)) : V("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), u4 = {
  name: "VtBreadcrumbItem",
  inheritAttrs: !1
}, P4 = /* @__PURE__ */ g({
  ...u4,
  props: {
    text: {},
    tagName: { default: "a" },
    options: { default() {
      return [];
    } }
  },
  setup(i) {
    const a = i, r = H({
      classes: {
        container: "relative",
        indicatorIcon: "",
        popover: "absolute right-0 top-full z-20 mt-1 flex min-w-max max-w-xs flex-col overflow-hidden rounded border border-neutral-200 bg-white shadow-lg outline-none dark:border-neutral-900 dark:bg-neutral-800",
        popoverAction: "",
        action: "flex items-center gap-1 rounded px-2 py-1 outline-none hover:bg-neutral-200/75 focus:bg-neutral-200/75 focus-visible:ring-4 focus-visible:ring-neutral-400/50 active:bg-neutral-200 dark:hover:bg-neutral-600/50 dark:focus:bg-neutral-600/50 dark:active:bg-neutral-600/75",
        li: 'flex items-center  text-neutral-500 before:px-0.5 before:font-normal before:text-neutral-300 hover:text-neutral-900 dark:text-neutral-300 dark:before:text-neutral-500 [&:last-child]:font-semibold [&:last-child]:text-neutral-900 dark:[&:last-child]:text-white [&:not(:first-child)]:before:content-["/"]',
        text: ""
      }
    }), s = d(() => r()), t = d(() => !!a.options.length), l = d(() => a.options.map((n) => ({
      key: n.text,
      props: {
        text: n.text,
        tagName: n.tagName || "a",
        ...n.props
      }
    })));
    return (n, u) => (o(), v("li", {
      class: e(s.value.li)
    }, [
      t.value ? (o(), b(h(P), {
        key: 0,
        as: "div",
        class: e(s.value.container)
      }, {
        default: m(({ open: c }) => [
          C(h(E), L(n.$attrs, {
            class: s.value.action
          }), {
            default: m(() => [
              p("span", {
                class: e(s.value.text)
              }, x(n.text), 3),
              C(w, {
                name: c ? "chevron-up" : "chevron-down",
                size: "sm",
                class: e(s.value.indicatorIcon)
              }, null, 8, ["name", "class"])
            ]),
            _: 2
          }, 1040, ["class"]),
          C(h(q), {
            class: e(s.value.popover)
          }, {
            default: m(() => [
              (o(!0), v($, null, A(l.value, (f) => (o(), b(h(R), L({
                key: f.key,
                as: J
              }, f.props), null, 16))), 128))
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      }, 8, ["class"])) : (o(), b(k(n.tagName), L({ key: 1 }, n.$attrs, {
        class: s.value.action
      }), {
        default: m(() => [
          p("div", {
            class: e(s.value.text)
          }, x(n.text), 3)
        ]),
        _: 1
      }, 16, ["class"]))
    ], 2));
  }
}), d4 = H({
  classes: {
    container: "relative",
    popover: "",
    button: "pointer-events-auto inline-flex max-w-full cursor-pointer flex-row items-center rounded-full font-medium focus:outline-none focus:ring-4",
    text: "truncate",
    icon: "flex-none",
    indicatorIcon: ""
  },
  defaultVariants: {
    intent: "secondary",
    size: "md",
    display: "normal",
    disabled: !1,
    iconPosition: "start"
  },
  variants: {
    intent: {
      primary: {
        button: "bg-primary-600 text-primary-50 hover:bg-primary-800 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
      },
      secondary: {
        button: "bg-success-500 text-success-50"
      },
      tertiary: {
        button: "bg-transparent text-neutral-900 hover:bg-neutral-100 focus:ring-neutral-200 dark:bg-neutral-800 dark:text-neutral-50 dark:hover:bg-neutral-700 dark:focus:ring-neutral-600"
      },
      system: {
        button: "bg-transparent text-neutral-900 hover:bg-neutral-100 focus:ring-neutral-200 dark:text-neutral-50 dark:hover:bg-neutral-700 dark:focus:ring-neutral-600"
      }
    },
    iconPosition: {
      start: { button: "flex-row" },
      end: { button: "flex-row-reverse" }
    },
    size: {
      sm: { button: "gap-1 px-2 py-1 text-xs", icon: "!h-3 !w-3" },
      md: { button: "gap-2 px-4 py-2 text-sm" },
      lg: { button: "gap-2 px-4 py-2 text-sm" }
    },
    display: {
      "full-width": {
        button: "w-full"
      },
      "icon-only": {
        text: "sr-only"
      }
    },
    type: {
      popover: {
        popover: 'absolute left-full top-0 z-20 ml-4 w-fit min-w-[20rem] max-w-lg rounded-xl border border-neutral-300 bg-neutral-50 p-4 shadow-lg after:absolute after:-left-2 after:top-6 after:h-4 after:w-4 after:rotate-45 after:transform after:border-b after:border-l after:border-b-neutral-300 after:border-l-neutral-300 after:bg-neutral-50 after:content-[""] dark:border-neutral-600 dark:bg-neutral-700 dark:after:border-b-neutral-600 dark:after:border-l-neutral-600 dark:after:bg-neutral-700'
      },
      menu: {
        popover: "absolute right-0 top-full z-20 mt-1 min-w-max max-w-xs overflow-hidden rounded border border-neutral-300 bg-neutral-50 shadow-lg dark:border-neutral-600 dark:bg-neutral-700"
      }
    }
  },
  compoundVariants: [
    {
      size: ["sm", "md", "lg"],
      display: "icon-only",
      classes: { button: "!p-2" }
    }
  ]
}), p4 = {
  name: "VtButton",
  inheritAttrs: !1
}, K = /* @__PURE__ */ g({
  ...p4,
  props: {
    text: {},
    type: { default: "button" },
    intent: { default: "tertiary" },
    tagName: { default: "button" },
    icon: { default: void 0 },
    size: { default: "md" },
    display: { default: "normal" },
    disabled: { type: Boolean },
    menuItems: { default() {
      return [];
    } }
  },
  setup(i) {
    const a = i, r = d(() => typeof a.icon == "object" ? a.icon.icon : a.icon), s = d(() => typeof a.icon == "object" ? a.icon.position ?? "start" : "start"), t = d(() => d4({
      type: a.type,
      intent: a.intent,
      size: a.size,
      display: a.display,
      disabled: a.disabled,
      iconPosition: s.value
    })), l = d(() => a.display === "icon-only" ? a.text : void 0), n = d(() => (a.type === "menu" || a.type === "popover") && a.display !== "icon-only"), u = d(() => a.menuItems.map((c) => ({
      key: c.text,
      disabled: c.disabled,
      props: c
    })));
    return (c, f) => c.type === "popover" ? (o(), b(h(O), {
      key: 0,
      class: e(t.value.container)
    }, {
      default: m(() => [
        C(h(F), L({
          disabled: c.disabled,
          class: t.value.button,
          title: l.value
        }, c.$attrs), {
          default: m(() => [
            r.value ? (o(), b(w, {
              key: 0,
              name: r.value,
              class: e(t.value.icon)
            }, null, 8, ["name", "class"])) : V("", !0),
            p("span", {
              class: e(t.value.text)
            }, x(c.text), 3)
          ]),
          _: 1
        }, 16, ["disabled", "class", "title"]),
        C(h(X), {
          class: e(t.value.popover)
        }, {
          default: m(() => [
            z(c.$slots, "popover")
          ]),
          _: 3
        }, 8, ["class"])
      ]),
      _: 3
    }, 8, ["class"])) : c.type === "menu" ? (o(), b(h(P), {
      key: 1,
      as: "div",
      class: e(t.value.container)
    }, {
      default: m(() => [
        C(h(E), L({
          disabled: c.disabled,
          class: t.value.button,
          title: l.value
        }, c.$attrs), {
          default: m(() => [
            r.value ? (o(), b(w, {
              key: 0,
              name: r.value,
              class: e(t.value.icon)
            }, null, 8, ["name", "class"])) : V("", !0),
            p("span", {
              class: e(t.value.text)
            }, x(c.text), 3),
            n.value ? (o(), b(w, {
              key: 1,
              name: "chevron-down",
              size: "sm",
              class: e(t.value.indicatorIcon)
            }, null, 8, ["class"])) : V("", !0)
          ]),
          _: 1
        }, 16, ["disabled", "class", "title"]),
        C(h(q), {
          class: e(t.value.popover)
        }, {
          default: m(() => [
            (o(!0), v($, null, A(u.value, (M) => (o(), b(h(R), L({
              key: M.key,
              disabled: M.disabled,
              as: J
            }, M.props), null, 16, ["disabled"]))), 128))
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["class"])) : (o(), b(k(c.tagName), L({
      key: 2,
      type: c.type,
      disabled: c.disabled,
      class: t.value.button,
      title: l.value
    }, c.$attrs), {
      default: m(() => [
        r.value ? (o(), b(w, {
          key: 0,
          name: r.value,
          class: e(t.value.icon)
        }, null, 8, ["name", "class"])) : V("", !0),
        p("span", {
          class: e(t.value.text)
        }, x(c.text), 3)
      ]),
      _: 1
    }, 16, ["type", "disabled", "class", "title"]));
  }
}), v4 = H({
  classes: {
    container: "",
    overlay: "fixed inset-0 z-30 bg-neutral-900 opacity-50 dark:opacity-80",
    dialog: "fixed inset-0 z-30 m-auto flex h-fit max-h-full w-11/12 max-w-lg flex-col rounded-lg bg-neutral-50 shadow dark:bg-neutral-700",
    hgroup: "flex items-center justify-between gap-4 rounded-t border-b px-6 py-4 dark:border-neutral-600",
    hgroupText: "text-base font-semibold text-neutral-900 dark:text-neutral-50 lg:text-xl",
    hgroupAction: "",
    main: "max-h-[40rem] flex-1 overflow-y-auto p-6"
  }
}), f4 = {
  name: "VtDialog"
}, E4 = /* @__PURE__ */ g({
  ...f4,
  props: {
    open: { type: Boolean },
    titleText: {},
    initialFocus: { default: void 0 }
  },
  emits: ["update:open", "open", "close"],
  setup(i, { emit: a }) {
    const r = i, s = () => {
      a("update:open", !1);
    }, t = d(() => v4());
    return j(
      () => r.open,
      (l) => {
        a(l ? "open" : "close");
      },
      { flush: "post" }
    ), (l, n) => (o(), b(h(Y), {
      as: "div",
      class: e(t.value.container),
      open: l.open,
      "initial-focus": h(l.initialFocus),
      onClose: s
    }, {
      default: m(() => [
        p("div", {
          class: e(t.value.overlay),
          "aria-hidden": "true"
        }, null, 2),
        C(h(U), {
          class: e(t.value.dialog)
        }, {
          default: m(() => [
            p("hgroup", {
              class: e(t.value.hgroup)
            }, [
              C(h(G), {
                as: "h3",
                class: e(t.value.hgroupText)
              }, {
                default: m(() => [
                  B(x(l.titleText), 1)
                ]),
                _: 1
              }, 8, ["class"]),
              C(K, {
                type: "button",
                display: "icon-only",
                icon: "xmark",
                text: "Close dialog",
                intent: "system",
                class: e(t.value.hgroupAction),
                onClick: s
              }, null, 8, ["class"])
            ], 2),
            p("div", {
              class: e(t.value.main)
            }, [
              z(l.$slots, "default")
            ], 2)
          ]),
          _: 3
        }, 8, ["class"])
      ]),
      _: 3
    }, 8, ["class", "open", "initial-focus"]));
  }
}), m4 = H({
  classes: {
    container: "",
    overlay: "fixed inset-0 z-30 bg-neutral-900 opacity-50 dark:opacity-80",
    dialog: "fixed z-30 flex h-full w-11/12 max-w-lg flex-col bg-neutral-50 shadow dark:bg-neutral-700",
    hgroup: "items-center gap-4 rounded-t border-b px-6 py-4 dark:border-neutral-600",
    hgroupStart: "",
    hgroupText: "flex-1 text-base font-semibold text-neutral-900 dark:text-neutral-50 lg:text-xl",
    hgroupAction: "",
    main: "flex-1 overflow-y-auto p-2"
  },
  variants: {
    position: {
      start: {
        dialog: "left-0 top-0 rounded-r-xl",
        hgroup: "flex justify-between"
      },
      end: {
        dialog: "right-0 top-0 rounded-l-xl",
        hgroup: "flex flex-row-reverse justify-end"
      }
    }
  }
}), b4 = {
  name: "VtDrawer"
}, q4 = /* @__PURE__ */ g({
  ...b4,
  props: {
    open: { type: Boolean },
    titleText: {},
    initialFocus: { default: void 0 },
    position: { default: "start" }
  },
  emits: ["update:open", "open", "close"],
  setup(i, { emit: a }) {
    const r = i, s = () => {
      a("update:open", !1);
    }, t = d(() => m4({ position: r.position }));
    return j(
      () => r.open,
      (l) => {
        a(l ? "open" : "close");
      },
      { flush: "post" }
    ), (l, n) => (o(), b(h(Y), {
      as: "div",
      class: e(t.value.container),
      open: l.open,
      "initial-focus": h(l.initialFocus),
      onClose: s
    }, {
      default: m(() => [
        p("div", {
          class: e(t.value.overlay),
          "aria-hidden": "true"
        }, null, 2),
        C(h(U), {
          class: e(t.value.dialog)
        }, {
          default: m(() => [
            p("hgroup", {
              class: e(t.value.hgroup)
            }, [
              l.$slots.titleStart ? (o(), v("div", {
                key: 0,
                class: e(t.value.hgroupStart)
              }, [
                z(l.$slots, "titleStart")
              ], 2)) : V("", !0),
              C(h(G), {
                as: "h3",
                class: e(t.value.hgroupText)
              }, {
                default: m(() => [
                  z(l.$slots, "title", {}, () => [
                    B(x(l.titleText), 1)
                  ])
                ]),
                _: 3
              }, 8, ["class"]),
              C(K, {
                type: "button",
                display: "icon-only",
                icon: "xmark",
                text: "Close drawer",
                intent: "system",
                class: e(t.value.hgroupAction),
                onClick: s
              }, null, 8, ["class"])
            ], 2),
            p("div", {
              class: e(t.value.main)
            }, [
              z(l.$slots, "default")
            ], 2)
          ]),
          _: 3
        }, 8, ["class"])
      ]),
      _: 3
    }, 8, ["class", "open", "initial-focus"]));
  }
}), h4 = {
  name: "VtMenu"
}, R4 = /* @__PURE__ */ g({
  ...h4,
  props: {
    tagName: { default: "div" }
  },
  setup(i) {
    const a = H({
      classes: {
        container: "",
        ul: ""
      }
    }), r = d(() => a());
    return (s, t) => (o(), b(k(s.tagName), {
      class: e(r.value.container)
    }, {
      default: m(() => [
        z(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), x4 = H({
  defaultVariants: {
    active: !1
  },
  classes: {
    nav: "flex h-full w-24 flex-col gap-12 bg-neutral-950",
    brand: "px-2 py-4",
    ul: "flex flex-col gap-6"
  }
}), V4 = {
  name: "VtNav"
}, O4 = /* @__PURE__ */ g({
  ...V4,
  setup(i) {
    const a = d(() => x4());
    return (r, s) => (o(), v("nav", {
      class: e(a.value.nav)
    }, [
      p("div", {
        class: e(a.value.brand)
      }, [
        z(r.$slots, "brand")
      ], 2),
      p("ul", {
        class: e(a.value.ul)
      }, [
        z(r.$slots, "default")
      ], 2)
    ], 2));
  }
}), C4 = H({
  defaultVariants: {
    active: !1
  },
  classes: {
    li: "",
    actionContainer: "relative flex items-center justify-center",
    action: "flex w-full cursor-pointer flex-col items-center gap-1",
    iconContainer: "rounded-xl p-2",
    icon: "",
    text: "flex items-center gap-1 break-all px-px text-xs",
    textEndIcon: "!h-2 !w-2",
    popover: 'absolute left-full top-0 z-20 ml-4 w-fit min-w-[20rem] max-w-lg rounded-xl border bg-neutral-50 p-4 shadow-lg after:absolute after:-left-2 after:top-6 after:h-4 after:w-4 after:rotate-45 after:transform after:border-b after:border-l after:bg-neutral-50 after:content-[""] dark:border-neutral-600 dark:bg-neutral-700 dark:after:border-b-neutral-600 dark:after:border-l-neutral-600 dark:after:bg-neutral-700'
  },
  variants: {
    active: {
      true: {
        action: "text-white",
        iconContainer: "bg-primary-500"
      },
      false: {
        action: "text-neutral-300 hover:text-white focus:text-white"
      }
    }
  }
}), z4 = {
  name: "VtNavItem",
  inheritAttrs: !1
}, F4 = /* @__PURE__ */ g({
  ...z4,
  props: {
    icon: {},
    type: {},
    text: {},
    textEndIcon: { default: void 0 },
    tagName: { default: void 0 },
    active: { type: Boolean }
  },
  setup(i) {
    const a = i, r = S(), s = d(() => C4({ active: a.active })), t = d(() => a.type === "popover" ? F : a.tagName ? a.tagName : a.type === "link" ? "a" : "button"), l = d(() => a.type === "popover" ? O : "div"), n = d(() => t.value === "button" ? { type: "button", ...r } : r);
    return (u, c) => (o(), v("li", {
      class: e(s.value.li)
    }, [
      (o(), b(k(l.value), {
        class: e(s.value.actionContainer)
      }, {
        default: m(() => [
          (o(), b(k(t.value), L({
            class: s.value.action
          }, n.value), {
            default: m(() => [
              p("span", {
                class: e(s.value.iconContainer)
              }, [
                C(w, {
                  name: u.icon,
                  size: "lg",
                  class: e(s.value.icon)
                }, null, 8, ["name", "class"])
              ], 2),
              p("span", {
                class: e(s.value.text)
              }, [
                B(x(u.text) + " ", 1),
                u.textEndIcon ? (o(), b(w, {
                  key: 0,
                  name: u.textEndIcon,
                  class: e(s.value.textEndIcon)
                }, null, 8, ["name", "class"])) : V("", !0)
              ], 2)
            ]),
            _: 1
          }, 16, ["class"])),
          u.type === "popover" ? (o(), b(h(X), {
            key: 0,
            class: e(s.value.popover)
          }, {
            default: m(() => [
              z(u.$slots, "popover")
            ]),
            _: 3
          }, 8, ["class"])) : V("", !0)
        ]),
        _: 3
      }, 8, ["class"]))
    ], 2));
  }
}), g4 = H({
  classes: {
    ul: "flex flex-wrap text-neutral-700 dark:text-neutral-200",
    li: "relative flex gap-2 rounded p-2",
    inputContainer: "z-10 flex h-5 items-center",
    input: "h-4 w-4 border-neutral-300 bg-neutral-100 text-primary-600 focus:ring-2 focus:ring-primary-500 dark:border-neutral-500 dark:bg-neutral-600 dark:ring-offset-neutral-700 dark:focus:ring-primary-600 dark:focus:ring-offset-neutral-700",
    textContainer: "",
    // ::after used to make sure the entire li is clickable
    label: "text-sm font-medium text-neutral-900 after:absolute after:inset-0 after:content-[''] dark:text-neutral-100",
    description: "text-xs font-normal text-neutral-500 dark:text-neutral-300"
  },
  defaultVariants: {
    direction: "row",
    optionBasis: "auto",
    required: !1,
    disabled: !1
  },
  variants: {
    disabled: {
      false: {
        li: "hover:bg-neutral-100 dark:hover:bg-neutral-600"
      }
    },
    direction: {
      row: {
        ul: "flex-row"
      },
      col: {
        ul: "flex-col"
      }
    },
    optionBasis: {
      auto: {
        li: "basis-auto"
      },
      "1/2": {
        li: "basis-1/2"
      },
      "1/3": {
        li: "basis-1/3"
      },
      "1/4": {
        li: "basis-1/4"
      },
      "1/5": {
        li: "basis-1/5"
      },
      "1/6": {
        li: "basis-1/6"
      }
    }
  }
}), H4 = ["id", "aria-labelledby", "aria-describedby", "name", "required", "disabled", "value"], L4 = ["id", "for"], M4 = ["id"], X4 = /* @__PURE__ */ g({
  __name: "VtRadio",
  props: {
    name: { default: _() },
    modelValue: { default: void 0 },
    options: {},
    direction: { default: "row" },
    optionBasis: { default: "auto" },
    required: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(i, { emit: a }) {
    const r = i, s = d(() => g4({
      direction: r.direction,
      optionBasis: r.optionBasis,
      required: r.required,
      disabled: r.disabled
    })), t = d(() => r.options.map((n) => {
      const u = _(), c = `label-${u}`, f = `description-${u}`;
      return {
        ...n,
        id: u,
        labelId: c,
        descriptionId: f,
        ariaLabelledBy: `#${c}`,
        ariaDescribedBy: `#${f}`
      };
    })), l = d({
      get() {
        return r.modelValue;
      },
      set(n) {
        a("update:modelValue", n);
      }
    });
    return (n, u) => (o(), v("ul", {
      class: e(s.value.ul)
    }, [
      (o(!0), v($, null, A(t.value, (c) => (o(), v("li", {
        key: c.value,
        class: e(s.value.li)
      }, [
        p("div", {
          class: e(s.value.inputContainer)
        }, [
          I(p("input", {
            id: c.id,
            "onUpdate:modelValue": u[0] || (u[0] = (f) => l.value = f),
            "aria-labelledby": c.labelId,
            "aria-describedby": c.descriptionId,
            type: "radio",
            name: n.name,
            required: n.required,
            disabled: n.disabled,
            value: c.value,
            class: e(s.value.input)
          }, null, 10, H4), [
            [Q, l.value]
          ])
        ], 2),
        p("div", {
          class: e(s.value.textContainer)
        }, [
          p("label", {
            id: c.labelId,
            for: c.id,
            class: e(s.value.label)
          }, x(c.labelText), 11, L4),
          c.descriptionText ? (o(), v("p", {
            key: 0,
            id: c.descriptionId,
            class: e(s.value.description)
          }, x(c.descriptionText), 11, M4)) : V("", !0)
        ], 2)
      ], 2))), 128))
    ], 2));
  }
}), w4 = H({
  classes: {
    label: "flex flex-col text-sm text-neutral-700 dark:text-neutral-300",
    inputContainer: "flex flex-row items-center gap-2",
    input: "flex-1",
    minLabel: "text-xs",
    maxLabel: "text-xs"
  }
}), y4 = ["for"], k4 = ["id", "min", "max", "step"], B4 = {
  name: "VtRange",
  inheritAttrs: !1
}, Y4 = /* @__PURE__ */ g({
  ...B4,
  props: {
    modelValue: {},
    labelText: {},
    minLabelText: { default: void 0 },
    maxLabelText: { default: void 0 },
    id: { default() {
      return _();
    } },
    min: { default: void 0 },
    max: { default: void 0 },
    step: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(i, { emit: a }) {
    const r = i, s = d({
      get() {
        return r.modelValue;
      },
      set(l) {
        a("update:modelValue", l);
      }
    }), t = d(() => w4());
    return (l, n) => (o(), v("label", {
      for: l.id,
      class: e(t.value.label)
    }, [
      B(x(l.labelText) + " ", 1),
      p("div", {
        class: e(t.value.inputContainer)
      }, [
        l.$slots.minLabel || l.minLabelText ? (o(), v("span", {
          key: 0,
          class: e(t.value.minLabel)
        }, [
          z(l.$slots, "minLabel", {}, () => [
            B(x(l.minLabelText), 1)
          ])
        ], 2)) : V("", !0),
        I(p("input", L({
          id: l.id,
          "onUpdate:modelValue": n[0] || (n[0] = (u) => s.value = u),
          type: "range",
          min: l.min,
          max: l.max,
          step: l.step
        }, l.$attrs, {
          class: t.value.input
        }), null, 16, k4), [
          [D, s.value]
        ]),
        l.$slots.maxLabel || l.maxLabelText ? (o(), v("span", {
          key: 1,
          class: e(t.value.maxLabel)
        }, [
          z(l.$slots, "maxLabel", {}, () => [
            B(x(l.maxLabelText), 1)
          ])
        ], 2)) : V("", !0)
      ], 2)
    ], 10, y4));
  }
}), U4 = /* @__PURE__ */ g({
  __name: "VtScrollableContainer",
  props: {
    tagName: { default: "div" },
    scrollX: { type: Boolean },
    scrollY: { type: Boolean }
  },
  setup(i) {
    const a = i, r = H({
      classes: {
        container: "h-full w-full scrollbar-thin scrollbar-track-neutral-600/25 scrollbar-thumb-neutral-600 scrollbar-thumb-rounded-full"
      },
      defaultVariants: {
        scrollX: !1,
        scrollY: !1
      },
      variants: {
        scrollX: {
          true: {
            container: "overflow-x-auto"
          }
        },
        scrollY: {
          true: {
            container: "overflow-y-auto"
          }
        }
      }
    }), s = d(() => r({
      scrollX: a.scrollX,
      scrollY: a.scrollY
    }));
    return (t, l) => (o(), b(k(t.tagName), {
      class: e(s.value.container)
    }, {
      default: m(() => [
        z(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), _4 = H({
  classes: {
    container: "relative",
    input: "w-full rounded border border-neutral-400 bg-neutral-50 focus-visible:!outline-none focus-visible:ring-4 focus-visible:ring-primary-300 dark:border-neutral-600 dark:bg-neutral-700",
    label: "absolute left-3 top-0 line-clamp-1 text-neutral-700 dark:text-neutral-300"
  },
  defaultVariants: {
    size: "md"
  },
  variants: {
    size: {
      sm: {
        input: "pb-0 pt-4",
        label: "text-xs leading-relaxed"
      },
      md: {
        input: "pb-3 pt-6",
        label: "text-sm leading-loose"
      }
    }
  }
}), $4 = ["for"], A4 = ["id", "type"], I4 = {
  name: "VtTextarea",
  inheritAttrs: !1
}, G4 = /* @__PURE__ */ g({
  ...I4,
  props: {
    labelText: {},
    modelValue: { default: void 0 },
    type: { default: "text" },
    size: { default: "md" },
    id: { default: () => `i${_()}` }
  },
  emits: ["update:modelValue"],
  setup(i, { expose: a, emit: r }) {
    const s = i, t = N();
    a({ input: t });
    const l = d(() => _4({ size: s.size })), n = d({
      get() {
        return s.modelValue;
      },
      set(u) {
        r("update:modelValue", u);
      }
    });
    return (u, c) => (o(), v("div", {
      class: e(l.value.container)
    }, [
      p("label", {
        class: e(l.value.label),
        for: u.id
      }, x(u.labelText), 11, $4),
      I(p("textarea", L({
        id: u.id,
        ref_key: "inputRef",
        ref: t,
        "onUpdate:modelValue": c[0] || (c[0] = (f) => n.value = f),
        type: u.type,
        class: l.value.input
      }, u.$attrs), null, 16, A4), [
        [D, n.value]
      ])
    ], 2));
  }
});
export {
  j4 as VtAlert,
  D4 as VtBreadcrumb,
  P4 as VtBreadcrumbItem,
  K as VtButton,
  E4 as VtDialog,
  q4 as VtDrawer,
  w as VtIcon,
  R4 as VtMenu,
  J as VtMenuItem,
  O4 as VtNav,
  F4 as VtNavItem,
  X4 as VtRadio,
  Y4 as VtRange,
  U4 as VtScrollableContainer,
  G4 as VtTextarea,
  H as defineComponentClasses
};
